module.exports = __webpack_public_path__ + "media/images/how_third-28e4325eefff67bde00f0cc652862375.svg";